import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators } from '../actions';

export const useActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(Creators, dispatch);
};
